/** @jsx jsx */
import { jsx } from '@emotion/react';

export default () => (
  <svg width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.20735 9.24176C9.20735 9.24176 10.8728 7.57634 11.4421 7.00817C13.2288 5.22142 12.3352 1.64676 12.3352 1.64676C12.3352 1.64676 8.76051 0.75309 6.97376 2.54042C5.63793 3.87626 4.74776 4.79617 4.74776 4.79617C4.74776 4.79617 2.50601 4.32717 1.16551 5.66767L8.31426 12.8164C9.65476 11.4759 9.20735 9.24176 9.20735 9.24176ZM8.33118 4.00051C8.78735 3.54434 9.52526 3.54434 9.98085 4.00051C10.437 4.45609 10.437 5.19401 9.98085 5.65017C9.52526 6.10576 8.78735 6.10576 8.33118 5.65017C7.8756 5.19401 7.8756 4.45667 8.33118 4.00051ZM1.73193 12.2319C1.73193 12.2319 3.48193 12.2319 4.6486 11.0653L2.8986 9.31526C1.73193 9.89859 1.73193 12.2319 1.73193 12.2319Z"
      fill="#00939C"
    />
  </svg>
);
